import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, NotificationType, Notification } from 'edenred-ui';
import { useOnboarding } from '@epi-shared/hooks/useOnboarding';

const NotificationCreateAnotherGroup = () => {
  const { t } = useTranslation();
  const { benefitGroupNotExists } = useOnboarding();

  if (!benefitGroupNotExists) {
    return null;
  }

  return (
    <Box>
      <Notification
        text={t('containers.benefit_groups.create_another.notification')}
        id={'create-another-notification'}
        type={NotificationType.Info}
      />
    </Box>
  );
};

export { NotificationCreateAnotherGroup };
